import {Divider, Grid} from "@mui/material";
import {LabelWithData, TextSize} from "../../../../../components/forms/LabelWithData";
import {
    Client,
    ClientAfipActivity,
    ClientAfipActivityFields,
    ClientFields, ClientType
} from "../../../../../types/client/clientData";
import {
    Solicitation,
    SolicitationFields
} from "../../../../../types/solicitation/solicitationData";
import {Addresses, Phones} from "../../../../solicitation-new/steps/components/components-company-data";
import {EntityWithIdFields} from "../../../../../types/baseEntities";
import {dateFormatter} from "../../../../../utils/formatters";
import {FontSubtitleTwo} from "../../../../solicitation-new/components/SharedTypography";
import React, {useEffect, useState} from "react";
import {HttpClientAfipActivity} from "../../../../../http/cache/client/httpClientAfipActivity";


interface SolicitationCompanyDataDetailProps {
    client?: Client,
    solicitation: Solicitation
}


const SolicitationCompanyDataDetail = ({client, solicitation}: SolicitationCompanyDataDetailProps) => {
    const [activity, setActivity] = useState<ClientAfipActivity>()
    
    useEffect(() => {
        if (client)
            HttpClientAfipActivity.getByIdClient(client[EntityWithIdFields.Id]).then((r) => 
                setActivity(r.find((a) => a[ClientAfipActivityFields.AfipActivityCode] === solicitation[SolicitationFields.AfipActivityCode]))
            )
    }, [client]);
    
    const isLegalPerson = client?.[ClientFields.ClientTypeCode] === ClientType.Juridica
    
    return (
        <Grid container spacing={4}>
            <Grid item xs={12}><Divider /></Grid>
            <Grid item xs={6} md={isLegalPerson ? 5 : 3} mt={2}>
                <LabelWithData label={'Nombre Comercial'} value={client?.[ClientFields.CommercialName]} labelSize={TextSize.Medium} valueSize={TextSize.Medium}/>
            </Grid>
            <Grid item xs={6} md={isLegalPerson ? 4.5 : 3} mt={2}>
                <LabelWithData label={'Sitio Web'} value={client?.[ClientFields.Website]} labelSize={TextSize.Medium} valueSize={TextSize.Medium}/>
            </Grid>
            <Grid item xs={6} md={isLegalPerson ? 2.5 : 3} mt={2}>
                <LabelWithData label={'Mail de Contacto'} value={solicitation[SolicitationFields.Mail]} labelSize={TextSize.Medium} valueSize={TextSize.Medium}/>
            </Grid>
            <Grid item xs={6} md={isLegalPerson ? 5 : 3} mt={2}>
                <LabelWithData label={'Responsabilidad AFIP'} value={client?.[ClientFields.AfipResponsibilityTypeDesc]} labelSize={TextSize.Medium} valueSize={TextSize.Medium}/>
            </Grid>
            {
                isLegalPerson &&
                <Grid item xs={6} md={7} mt={2}>
                    <LabelWithData label={'Clasificación'}
                                   value={client?.[ClientFields.ClientClassificationDesc]}
                                   valueSize={TextSize.Medium}
                    />
                </Grid>
            }
            <Grid item md={6} mt={2}>
                {client && <Addresses client={client} hideCheck/>}
            </Grid>
            <Grid item md={6} mt={2}>
                {client && <Phones clientId={client[EntityWithIdFields.Id]} />}
            </Grid>
                {
                    client &&
                    <Grid item md={12} container spacing={4} mt={4}>
                        <Grid item md={12}>
                            <FontSubtitleTwo text={"Actividad"} />
                        </Grid>
                        <Grid item md={12}>
                            <Divider />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <LabelWithData label={'Actividad principal'} value={client[ClientFields.AfipMainActivityDesc]}/>
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <LabelWithData label={'Fecha de inscripción en AFIP'} value={dateFormatter.toShortDate(client[ClientFields.AfipRegisterDate])} />
                        </Grid>
                        <Grid item md={3} xs={6}>
                            <LabelWithData label={'Año de inicio de actividades'} value={dateFormatter.toYearDate(client[ClientFields.ActivityStartDate])} />
                        </Grid>
                        <Grid item xs={12}>
                            {activity && <LabelWithData label={'Actividad por la cual solicita el credito'} value={activity[ClientAfipActivityFields.AfipActivityDesc]} />}
                        </Grid>
                    </Grid>
                }
            <Grid item md={12} container spacing={2} mt={2}>
                <Grid item md={12}>
                    <FontSubtitleTwo text={"Personal"} />
                </Grid>
                <Grid item md={12}>
                    <Divider />
                </Grid>
                <Grid item md={4}>
                    <LabelWithData label={'Personal ocupado'} value={solicitation[SolicitationFields.EmployeeQuantity]}/>
                </Grid>
                <Grid item md={4}>
                    <LabelWithData label={'Personal a incorporar'} value={solicitation[SolicitationFields.NewEmployeeQuantity]} />
                </Grid>
                <Grid item md={4}>
                    <LabelWithData label={'Porcentaje de mujeres en cargos jerarquicos'} value={solicitation[SolicitationFields.EmployeeQuantity]}/>
                </Grid>
            </Grid>
        </Grid>
    )
}


export default SolicitationCompanyDataDetail